import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { SnackbarService } from 'core/services';
import { filter, map, Observable, of, switchMap, take, tap } from 'rxjs';
import { designerPaths } from '../../designer.paths';
import { JwtRefreshService } from '../../global-services/jwt-refresh.service';
import { JwtService, LRole } from '../../global-services/jwt.service';
import { DsgDeepTranslationKey } from '../../pipes/translate.pipe';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  readonly #allowedRoles: LRole[] = ['ROLE_administrator', 'ROLE_process_creator', 'ROLE_signer']

  readonly jwtSubject = this._jwtService.jwtSubject;
  readonly refreshTokenExistsSubject = this._jwtService.refreshTokenExistsSubject;

  constructor(

    private readonly _jwtService: JwtService,
    private readonly _router: Router,
    private readonly _jwtRefreshService: JwtRefreshService,
    private readonly _snackbarService: SnackbarService<DsgDeepTranslationKey>
  ) {


  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {



    return this._jwtRefreshService.loggedInObs.pipe(
      switchMap((loggedIn) => {

        if (!loggedIn) {
          this._router.navigate([designerPaths.auth], { queryParams: { accessedRoutePath: state.url } })
          return of(false)
        }


        return this._jwtService.jwtDecodedSubject.pipe(
          filter(Boolean),
          map(({ roles }) => roles.some((role) => this.#allowedRoles.includes(role))),
          tap((hasValidRole) => {

            if (!hasValidRole) {

              this._snackbarService.open({ type: 'error', message: 'ss-auth.error.user-has-no-role' });
              this._jwtRefreshService.logout().pipe(take(1)).subscribe()

            }

          })
        )
      })
    )
  }

}
